import React, {
  useState,
  useEffect,
  useRef,
} from "react";

import { push } from "react-router-redux";
import { connect } from "react-redux";

import {
  Col,
  Row,
  MenuProps,
  Tooltip,
  Button,
  Flex,
  Typography,
  Dropdown,
  Popconfirm,
  Switch,
  Spin,
  Alert,
  Input,
  Space,
  Segmented,
  Radio,
  message as antdMessage,
} from "antd";
import {
  CalendarFilled,
  ExclamationCircleOutlined,
  MoreOutlined,
  PaperClipOutlined,
  RobotOutlined,
  SendOutlined,
  LockOutlined,
  StopOutlined,
  TranslationOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
// import ScrollableLoadMore from "../ScrollableLoadMore";
import { useStore } from "../../inbox-store";
import { getSequencePreview, enrollContactInSequence, translateText as translateTextApi } from "../../resources";
import session from "../../../../utils/session";
import { getUserLanguage, langName } from "../../../../utils/languages";
import human from "humanparser";
import _ from "lodash";
import {
  parseNewLine,
  isValidPhoneNumberIntl,
} from "../helpers/ui";

import constants from "../../../../constants";
import MessageRichEditor from './MessageRichEditor';
import { showError, showSuccess, showWarning } from '../../utils/errorMessages';
import CalendarOwnerPicker from '../../../common/CalendarOwnerPicker';
import {
  useFeature,
  LockedControl,
  FeatureLockBanner,
} from '../../../common/FeatureGate';
import { openUpgradeModal } from '../../../common/upgradeModalStore';
import { getUserSettings, getCalendarPreview } from '../../../user-management/api';
// ADR-025 multi-channel composer
import { CHANNEL_CONFIG, getAvailableChannels, Channel } from '../../../../utils/channels';
import { useWhatsappWindow } from '../../../../hooks/useWhatsappWindow';
import { formatExpiry, formatRemaining } from '../../../../utils/whatsappWindow';
import ChannelIcon from '../../../common/ChannelIcon';
import { WhatsAppWindowChip } from '../WhatsAppWindowChip';
import {
  FALLBACK_SEND_LABEL,
  WhatsAppFallback,
  defaultComposerChannel,
  defaultFallback,
  effectiveLastInboundAt,
  fallbackAvailability,
  findSmsLongcode,
  latestInboundThread,
  resolveSendBotmap,
  renderWindowTemplatePreview,
  sendResultToastKey,
  templateFallbackHint,
} from '../../utils/whatsappChannel';
import { getWhatsAppWindow, WhatsAppWindowInfo } from '../../../../reducers/whatsapp/resources';

import './MessageInputField.css';
const { Text } = Typography;

const MessageInputField = ({
  goToCalendarIntegration: reduxGoToCalendarIntegration,
  onSchedulingChange,
  // New props for decoupling
  activeContactModel: propActiveContactModel,
  sendMessage: propSendMessage,
  userMessageTemplates: propUserMessageTemplates,
  userSequenceTemplates: propUserSequenceTemplates,
  userHasCalendar: propUserHasCalendar,
  sendCalendarInvite: propSendCalendarInvite,
  onCalendarSetup: propOnCalendarSetup,
}) => {
  const goToCalendarIntegration = propOnCalendarSetup || reduxGoToCalendarIntegration;
  const storeActiveContactModel = useStore((state) => state.activeContactModel);
  const retrieveContactThreads = useStore((state) => state.retrieveContactThreads);
  const storeUserMessageTemplates = useStore((state) => state.userMessageTemplates);
  const storeUserSequenceTemplates = useStore((state) => state.userSequenceTemplates);
  const storeUserHasCalendar = useStore((state) => state.userHasCalendar);
  const storeSendCalendarInvite = useStore((state) => state.sendCalendarInvite);
  const storeSendMessage = useStore((state) => state.sendMessage);
  // ADR-025: channel selection + live WhatsApp window
  const composerChannel = useStore((state) => state.composerChannel);
  const setComposerChannel = useStore((state) => state.setComposerChannel);
  const storeThreads = useStore((state) => state.threads);
  const storeFilters = useStore((state) => state.filters);
  const applyScheduledMessageSocketEvent = useStore((state) => state.applyScheduledMessageSocketEvent);

  const activeContactModel = propActiveContactModel || storeActiveContactModel;
  const userMessageTemplates = propUserMessageTemplates || storeUserMessageTemplates;
  const userSequenceTemplates = propUserSequenceTemplates || storeUserSequenceTemplates || [];
  const userHasCalendar = propUserHasCalendar || storeUserHasCalendar;
  const sendCalendarInvite = propSendCalendarInvite || storeSendCalendarInvite;
  const sendMessage = propSendMessage || storeSendMessage;

  const activeContact = activeContactModel?.id;

  const [hasCalendarConnected, setHasCalendarConnected] = useState(false);
  const [isCalendarSetupConfirmOpen, setIsCalendarSetupConfirmOpen] = useState(false);
  const [isSwitchLoading, setIsSwitchLoading] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [messageHasScheduling, setMessageHasScheduling] = useState(false);
  const [isInterviewInviteConfirmOpen, setIsInterviewInviteConfirmOpen] = useState(false);
  const [inviteMessage, setInviteMessage] = useState("");
  const [isTurnOffConfirmOpen, setIsTurnOffConfirmOpen] = useState(false);
  const [isProcessingLinks, setIsProcessingLinks] = useState(false);
  const [excludedClearTrigger, setExcludedClearTrigger] = useState(0);
  const [message, setMessage] = useState("");
  // Scheduling-manager: which teammate's calendar this invite books onto (self by default).
  const hasSchedulingManager = useFeature('scheduling-manager');
  // Feature-RBAC gates for this composer. It is the ONLY composer in the app —
  // inbox-v2, the sidebar quick-send, the contact profile, the campaign contact
  // drawer and account-setup all mount this component — so gating here covers
  // every 1-1 / reply surface.
  const canSend = useFeature('messaging.send');
  const canUseTemplates = useFeature('templates.use');
  const canSchedule = useFeature('interview-scheduling');
  const [schedulingUserId, setSchedulingUserId] = useState<string | undefined>(undefined);
  // Available-slot count for the calendar the invite will book on (null = still
  // fetching). Used to block sending an invite that can't be booked (0 slots).
  const [bookingSlotCount, setBookingSlotCount] = useState<number | null>(null);
  const [templateMenuItems, setTemplateMenuItems] = useState<any>([]);
  const [sequenceMenuItems, setSequenceMenuItems] = useState<any>([]);
  const [pendingSequence, setPendingSequence] = useState<any>(null); // tracks sequence to enroll after send
  const isSendingRef = useRef(false);

  // ── AI translation (ADR-035) ──
  // The recruiter types in their own language; with the switch on, Send first
  // fetches a translation into the contact's language and shows it in an
  // editable preview panel. Nothing goes out unseen. `body` sent = the previewed
  // text; `translation` metadata records what was typed so the bubble can show it.
  const canTranslate = useFeature('ai-translation');
  const viewerLang = getUserLanguage();
  const contactLang: string | null = activeContactModel?.language || null;
  // The New Message modal passes a sentinel contact ('new-message') whose `language`
  // comes from the by-mobile lookup or the Candidate language picker — a known
  // language is all that matters here, not whether the contact row exists yet.
  const isRealContact = !!activeContact && activeContact !== 'new-message';
  const languageDiffers = !!contactLang && contactLang !== viewerLang;
  const translationAvailable = canTranslate && !!activeContact && languageDiffers;
  const translateStorageKey = isRealContact ? `inbox.translate.${activeContact}` : null;
  const [translateOn, setTranslateOn] = useState(true);
  const [isTranslating, setIsTranslating] = useState(false);
  const [preview, setPreview] = useState<{ text: string; original: string; sourceLang: string; targetLang: string; invite?: boolean } | null>(null);
  const [previewError, setPreviewError] = useState<{ code?: string; message: string } | null>(null);
  // Interview invites are translated whole (recruiter text + the booking sentence) and
  // go out through sendCalendarInvite with the same translation metadata.
  const willTranslate = translationAvailable && translateOn;

  // ── Channel (ADR-025) ──
  // Threads only live in the inbox store; other hosts (profile, campaign drawer)
  // get an empty list and therefore default to SMS.
  const availableChannels = React.useMemo(() => getAvailableChannels(activeContactModel), [activeContactModel]);
  const smsChannel = availableChannels.find((c) => c.type === 'sms');
  const waChannel = availableChannels.find((c) => c.type === 'whatsapp');
  const companyHasWhatsApp = React.useMemo(
    () => Array.isArray(storeFilters) && storeFilters.some((f: any) => f?.type === 'bot' && f?.channel === 'whatsapp'),
    [storeFilters],
  );
  const defaultChannel: Channel = React.useMemo(
    () => defaultComposerChannel(storeThreads, availableChannels),
    [storeThreads, availableChannels],
  );
  const selectedChannel: Channel = composerChannel && availableChannels.some((c) => c.type === composerChannel)
    ? composerChannel
    : defaultChannel;
  const isWhatsApp = selectedChannel === 'whatsapp';
  const showChannelPicker = !!activeContact && isRealContact && (availableChannels.length > 1 || (companyHasWhatsApp && !!smsChannel));
  const maxLen: number = (isWhatsApp ? CHANNEL_CONFIG.whatsapp.charLimit : null) || constants.maxMessageLength;
  // Only inbound threads pushed after this contact model loaded can reopen the window.
  const modelLoadedAt = React.useMemo(() => Date.now(), [activeContactModel]);
  const latestWaInbound = latestInboundThread(storeThreads, 'whatsapp', modelLoadedAt);
  const waLastInboundAt = effectiveLastInboundAt(waChannel, storeThreads, modelLoadedAt);
  const windowState = useWhatsappWindow(waLastInboundAt, [latestWaInbound?.id]);
  const needsFallback = isWhatsApp && !windowState.open;
  const smsLongcode = findSmsLongcode(session.get("userData")?.bots);
  // ADR-037: the closed-window strip shows the sender's real `reengage` template.
  const waConversationId = waChannel?.conversationId || null;
  const [waWindowInfo, setWaWindowInfo] = useState<WhatsAppWindowInfo | null>(null);
  useEffect(() => {
    if (!needsFallback || !waConversationId) {
      setWaWindowInfo(null);
      return undefined;
    }
    let cancelled = false;
    getWhatsAppWindow(String(waConversationId))
      .then((info) => { if (!cancelled) setWaWindowInfo(info); })
      .catch(() => { if (!cancelled) setWaWindowInfo(null); });
    return () => { cancelled = true; };
  }, [needsFallback, waConversationId]);
  const waTemplate = waWindowInfo?.template || null;
  const baseAvailability = fallbackAvailability({
    hasMobile: !!activeContactModel?.mobile && isValidPhoneNumberIntl(activeContactModel?.mobile),
    optedOut: !!activeContactModel?.blacklist,
    hasSmsBotmap: !!smsLongcode,
  });
  // Only an explicit "no template" from the window endpoint disables the option.
  const availability = waWindowInfo?.fallbacks?.template === false
    ? { ...baseAvailability, template: false }
    : baseAvailability;
  const [fallbackChoice, setFallbackChoice] = useState<WhatsAppFallback>(() => defaultFallback(availability));
  // Re-derive the default (first enabled of SMS → template → hold) whenever the
  // contact changes or availability shifts — the model loads after first mount,
  // so the initial value above is only a placeholder.
  useEffect(() => {
    setFallbackChoice(defaultFallback(availability));
  }, [activeContactModel?.id, availability.sms, availability.template, availability.hold]);
  const contactFirstName = human.parseName(activeContactModel?.name || '').firstName || activeContactModel?.name || 'there';

  const persistTranslateOn = (value: boolean) => {
    setTranslateOn(value);
    try {
      if (translateStorageKey) window.localStorage.setItem(translateStorageKey, value ? '1' : '0');
    } catch {
      // localStorage unavailable — in-memory only
    }
  };

  const messageMenuItems: MenuProps["items"] = [
    {
      type: 'group',
      label: <><PaperClipOutlined /> Templates</>,
      children: canUseTemplates ? templateMenuItems : [
        {
          key: 'templates-locked',
          label: (
            <span style={{ fontSize: 'smaller' }}>
              <LockOutlined style={{ marginRight: 6, color: '#faad14' }} />
              Templates aren’t in your plan — learn more
            </span>
          ),
          onClick: () => openUpgradeModal('templates.use'),
        },
      ],
    },
    {
      type: 'group',
      label: <><RobotOutlined /> Sequences</>,
      children: sequenceMenuItems.length > 0 ? sequenceMenuItems : [
        { key: 'no-sequences', label: <Text type="secondary" style={{ fontSize: 'smaller' }}>No sequences available</Text>, disabled: true },
      ],
    },
  ];

  // The actual send. `body` is what goes over the wire; `translation` (optional)
  // is the ADR-035 metadata { lang, alt_lang, alt_text } for a previewed translation.
  const doSend = async (body: string, translation: { lang: string; alt_lang: string; alt_text: string } | null) => {
    if (!canSend) return; // gated: also reachable via Enter-to-send
    if (isSendingRef.current) return;
    isSendingRef.current = true;
    setIsSending(true);

    const userData = session.get("userData");
    const channel: Channel = selectedChannel;
    const fail = (key: Parameters<typeof showError>[0], custom?: string) => {
      showError(key, custom);
      isSendingRef.current = false;
      setIsSending(false);
    };

    // ADR-025: which line carries this message. SMS = the user's 1-1 number;
    // WhatsApp = the company sender attached to the contact's WhatsApp channel.
    const resolved = resolveSendBotmap(channel, userData?.bots, activeContactModel);
    if (resolved.error) {
      fail(resolved.error);
      return;
    }

    //check if can send to contact
    if (channel === 'sms' && !isValidPhoneNumberIntl(activeContactModel.mobile)) {
      fail('invalidPhoneNumber');
      return;
    }
    if (channel === 'whatsapp' && !resolved.to) {
      fail('noWhatsAppNumber', 'This contact has no WhatsApp number.');
      return;
    }

    const sendOpts = channel === 'whatsapp'
      ? { channel, fallback: needsFallback ? fallbackChoice : undefined }
      : { channel };

    //send
    try {
      const res: any = await sendMessage(
        body,
        resolved.botmapId as string,
        activeContactModel.id,
        resolved.to,
        pendingSequence?.modulegroup_id,
        translation || undefined,
        sendOpts,
      );
      const result = (res && res.data && typeof res.data === 'object') ? res.data : {};

      // Enrollment is handled server-side by /api/v1/conversation/send when moduleGroup
      // is in the body. Just refresh threads so the newly-scheduled bubbles appear.
      // Skip the refresh for the New Message modal — activeContactModel.id is a sentinel
      // ('new-message') there and the modal closes anyway.
      if (pendingSequence) {
        if (activeContactModel.id && activeContactModel.id !== 'new-message') {
          await retrieveContactThreads(activeContactModel.id, 1);
        }
        setPendingSequence(null);
      }

      setMessage("")
        setExcludedClearTrigger((s) => s + 1);
      setMessageHasScheduling(false)
      setPreview(null);
      setPreviewError(null);
      isSendingRef.current = false;
      setIsSending(false)

      // ADR-025: say what actually happened (free-form / template / SMS / held).
      // ADR-037: a template without a text slot sends the notice and holds the text.
      if (result.held) {
        showSuccess(sendResultToastKey(result, channel));
        // The pending bubble also arrives over the socket; push it now so the
        // recruiter sees it immediately. applyScheduledMessageSocketEvent dedupes by id.
        if (!propSendMessage && result.pendingId) {
          const convId = waChannel?.conversationId || result.thread?.conversation_id || null;
          applyScheduledMessageSocketEvent('scheduled_message:created', {
            id: result.pendingId,
            conversation_id: convId,
            conversation: { id: convId, contact_id: activeContactModel.id },
            direction: 'scheduled',
            created_at: new Date().toISOString(),
            message: body,
            kind: 'whatsapp_hold',
            user: { id: userData?.id || null, name: userData?.name || '', avatar_url: userData?.avatar_url || null },
            channel_name: userData?.name || '',
            channelDetails: { type: 'user', id: userData?.id || null, name: userData?.name || '', avatar_url: userData?.avatar_url || null },
          });
        }
      } else {
        showSuccess(sendResultToastKey(result, channel));
      }
    } catch (e) {
      showError('sendMessage');
      isSendingRef.current = false;
      setIsSending(false);
      return;
    }
  };

  const onPressSendMessage = () => doSend(message.trim(), null);

  // Translate switch ON: Send → fetch the translation → editable preview panel.
  const onPressTranslatePreview = async () => {
    if (!canSend || !contactLang) return;
    if (messageHasScheduling && !canSchedule) return;
    // Interview invites are translated WHOLE: recruiter text + the fixed booking
    // sentence, so the candidate reads one message in their language.
    const invite = messageHasScheduling;
    const original = invite ? message.trim() + constants.interviewInviteAppend : message.trim();
    if (!message.trim() || isTranslating || isSendingRef.current) return;
    setIsTranslating(true);
    setPreviewError(null);
    try {
      const res: any = await translateTextApi({
        text: original,
        target_lang: contactLang,
        source_lang: viewerLang,
        contactId: activeContactModel.id !== 'new-message' ? activeContactModel.id : undefined,
      });
      const d = (res && res.data) || res || {};
      if (d.same_language) {
        // Already in the contact's language (or nothing translatable, e.g. "2") — send as typed.
        antdMessage.info(`Already in ${langName(contactLang)} — sending as typed`);
        if (invite) await doSendInvite(original, null);
        else await doSend(original, null);
        return;
      }
      if (!d.translated) {
        setPreviewError({ code: d.outcome, message: `Couldn’t translate this message into ${langName(contactLang)}.` });
        return;
      }
      setPreview({
        text: d.translated,
        original,
        sourceLang: d.source_lang || viewerLang,
        targetLang: contactLang,
        invite,
      });
    } catch (err: any) {
      const code = err && (err.code || (err.data && err.data.code));
      let msg = (err && err.message) || 'Translation failed';
      if (code === 'TRANSLATION_DISABLED') msg = 'AI translation isn’t enabled for your company.';
      else if (code === 'TRANSLATION_CAPPED') msg = 'AI translation has reached its monthly limit for your company.';
      else if (code === 'TRANSLATION_FAILED') msg = 'Translation failed — nothing was sent.';
      setPreviewError({ code, message: msg });
    } finally {
      setIsTranslating(false);
    }
  };

  const onSendTranslated = async () => {
    if (!preview) return;
    const text = preview.text.trim();
    if (!text) return;
    const translation = { lang: preview.targetLang, alt_lang: preview.sourceLang, alt_text: preview.original };
    if (preview.invite) await doSendInvite(text, translation);
    else await doSend(text, translation);
  };

  const onSendOriginal = async () => {
    setPreview(null);
    setPreviewError(null);
    if (messageHasScheduling) await doSendInvite(message.trim() + constants.interviewInviteAppend, null);
    else await doSend(message.trim(), null);
  };

  // Interview invite send. `fullMessage` is the complete invite text going over the
  // wire (recruiter text + booking sentence, translated or not); `translation`
  // (ADR-035) records what the recruiter typed when it was previewed.
  const doSendInvite = async (fullMessage: string, translation: { lang: string; alt_lang: string; alt_text: string } | null) => {
    if (!canSend || !canSchedule) return; // gated
    if (isSendingRef.current) return;
    isSendingRef.current = true;
    setIsSending(true);
    //check if can send to contact
    if (!isValidPhoneNumberIntl(activeContactModel.mobile)) {
      showError('invalidPhoneNumber');
      isSendingRef.current = false;
      setIsSending(false);
      return;
    }
    //check that a usable calendar is connected — either the sender's own, or the
    //chosen teammate's when a scheduling manager books on their behalf.
    const currentUserId = String(session.get("userData")?.id || "");
    const bookingOnTeammate = !!schedulingUserId && schedulingUserId !== currentUserId;
    const calendarData = await userHasCalendar();
    const hasCalendarConnected = calendarData.length > 0;
    if (!hasCalendarConnected && !bookingOnTeammate) {
      isSendingRef.current = false;
      setIsSending(false);
      return;
    }

    //send
    try {
      await sendCalendarInvite(
        activeContactModel.mobile,
        activeContactModel.id,
        fullMessage,
        bookingOnTeammate ? schedulingUserId : undefined,
        translation || undefined,
      );
      showSuccess('calendarInviteSent');

      // ADR-027: enroll in the chosen sequence after the first message goes out.
      // The calendar-invite path uses the user's default longcode botmap server-side;
      // mirror that resolution here so enroll can resolve the conversation.
      if (pendingSequence) {
        try {
          const userData = session.get("userData");
          const textingBotMap = findSmsLongcode(userData?.bots);
          if (textingBotMap) {
            await enrollContactInSequence(
              pendingSequence.modulegroup_id,
              activeContactModel.id,
              { botmap_id: textingBotMap.botmap_id },
            );
            await retrieveContactThreads(activeContactModel.id, 1);
          }
        } catch (enrollErr) {
          console.error('Failed to enroll in sequence (calendar-invite path):', enrollErr);
        }
        setPendingSequence(null);
      }
    } catch (e) {
      showError('calendarInvite');
      isSendingRef.current = false;
      setIsSending(false);
      return;
    }
    setMessage("")
    setExcludedClearTrigger((s) => s + 1);
    setMessageHasScheduling(false)
    setPreview(null);
    setPreviewError(null);
    isSendingRef.current = false;
    setIsSending(false);
  };

  const onPressSendCalendarInvite = () => doSendInvite(message.trim() + constants.interviewInviteAppend, null);

  const onClickInterviewScheduling = async () => {
    if (!canSchedule) return; // gated
    const calendarData = await userHasCalendar();
    const hasCalendarConnected = calendarData.length > 0;
    const currentUserId = String(session.get("userData")?.id || "");
    if (hasCalendarConnected) {
      // Default to booking on the sender's own calendar.
      setSchedulingUserId(currentUserId);
      if (calendarData[0].invite_message) {
        setInviteMessage(replaceMergeFields(calendarData[0].invite_message));
      }
      if (message.trim() !== "") {
        setIsInterviewInviteConfirmOpen(true);
      } else {
        setMessageHasScheduling(true);
        if (calendarData[0].invite_message) {
          setMessage(replaceMergeFields(calendarData[0].invite_message));
        }
      }
    } else if (hasSchedulingManager) {
      // Scheduling manager with no personal calendar: enable scheduling and let
      // them pick a teammate's calendar below (invite text loads on selection).
      setSchedulingUserId(undefined);
      setMessageHasScheduling(true);
    }
    // else Popconfirm will handle
  };

  // Scheduling-manager: when a teammate is chosen, pull their invite message into
  // the composer (their template + calendar are what the candidate will book on).
  const onSchedulingUserChange = async (uid?: string) => {
    setSchedulingUserId(uid);
    const currentUserId = String(session.get("userData")?.id || "");
    if (!uid || uid === currentUserId) return;
    try {
      const res: any = await getUserSettings(uid);
      const s = res?.data?.data || res?.data || {};
      const invite = s.inviteMsg || s.invite_message;
      if (invite) setMessage(replaceMergeFields(invite));
    } catch {
      // non-fatal: the manager can type the message manually
    }
  };

  const onInterviewInviteConfirm = () => {
    setMessage(replaceMergeFields(inviteMessage));
    setMessageHasScheduling(true);
    setIsInterviewInviteConfirmOpen(false);
  };

  const onInterviewInviteCancel = () => {
    setMessage(message);
    setMessageHasScheduling(true);
    setIsInterviewInviteConfirmOpen(false);
  };

  const onTurnOffConfirm = () => {
    setMessage("");
    setExcludedClearTrigger((s) => s + 1);
    setMessageHasScheduling(false);
    setIsTurnOffConfirmOpen(false);
  };

  const onTurnOffCancel = () => {
    setMessageHasScheduling(false);
    setIsTurnOffConfirmOpen(false);
  };

  // Compose-time preview substitution. The authoritative merge happens server-side
  // in lib/message.js#constructMessage — keep this token list in sync with the
  // backend synonym table so the previewed message matches what's sent.
  const replaceMergeFields = (message) => {
    const userData = session.get("userData");
    const contact = human.parseName(activeContactModel.name);
    // Per-contact custom fields (contactdetail rows), matched by lowercase
    // field name like the backend does.
    const detail = (field: string): string =>
      _.find(
        activeContactModel?.contactdetails,
        (d: any) => (d?.field || "").toLowerCase() === field
      )?.value || "";
    const subs: Record<string, string> = {
      "{{firstname}}": contact.firstName,
      "{{lastname}}": contact.lastName,
      // Chrome extension Workday scrape
      "{{workday_position}}": detail("workday_position"),
      "{{workday_req_id}}": detail("workday_req_id"),
      // recruiter / user
      "{{recruiter}}": userData.name,
      "{{recruiter_name}}": userData.name,
      "{{recruitername}}": userData.name,
      // brand / company
      "{{brand}}": userData.companyName,
      "{{brand_name}}": userData.companyName,
      "{{brandname}}": userData.companyName,
      "{{company}}": userData.companyName,
      "{{company_name}}": userData.companyName,
      "{{companyname}}": userData.companyName,
    };
    Object.entries(subs).forEach(([token, value]) => {
      message = _.replace(message, new RegExp(token.replace(/[{}]/g, "\\$&"), "gi"), value || "");
    });
    return message;
  };

  useEffect(() => {
    const checkCalendar = async () => {
      const calendarData = await userHasCalendar();
      setHasCalendarConnected(calendarData.length > 0);
    };
    checkCalendar();
  }, []);

  useEffect(() => {
    console.log("messageInputField", "activeContactModel Changed");
    // Clear message when activeContact changes (including when cleared to null)
    setMessage(""); //clear the messagebox
    setExcludedClearTrigger((s) => s + 1);
    setMessageHasScheduling(false); // reset scheduling
    setPendingSequence(null); // clear any pending sequence enrollment
    setIsInterviewInviteConfirmOpen(false);
    setIsTurnOffConfirmOpen(false);
    setIsCalendarSetupConfirmOpen(false);
    // ADR-035: drop any translation preview; restore this contact's translate preference
    setPreview(null);
    setPreviewError(null);
    // ADR-025: back to the thread's default channel for the new contact
    setComposerChannel(null);
    try {
      const saved = activeContactModel?.id ? window.localStorage.getItem(`inbox.translate.${activeContactModel.id}`) : null;
      setTranslateOn(saved === null ? true : saved === '1');
    } catch {
      setTranslateOn(true);
    }
    if (!activeContactModel || !activeContactModel.id || !canUseTemplates) {
      return;
    }

    // Group templates by category
    const groupedTemplates = _.groupBy(userMessageTemplates, 'category');

    // Sort categories alphabetically ascending, case insensitive
    const sortedCategories = _.orderBy(Object.keys(groupedTemplates), [category => category.toLowerCase()], ['asc']);

    const newTemplates = _.map(sortedCategories, (category) => {
      const templates = groupedTemplates[category];
      return {
        key: category,
        label: category,
        children: _.map(_.orderBy(templates, [template => template.name.toLowerCase()], ['asc']), (rawTemplateData) => {
          const templateMessage = replaceMergeFields(rawTemplateData.details);

          return {
            key: rawTemplateData.id,
            label: (
              <Tooltip
                title={parseNewLine(templateMessage)}
                placement="right"
                color="#39b54a"
               styles={{body:{color:'white'}}}
              >
                <div
                  className="message-template-menu"
                  style={{ maxWidth: "220px" }}
                >
                  <Text ellipsis>
                    {rawTemplateData.name}
                  </Text>
                </div>
              </Tooltip>
            ),
            onClick: () => setMessage(templateMessage),
          };
        }),
      };
    });
    setTemplateMenuItems([...newTemplates]);
  }, [activeContactModel, userMessageTemplates, canUseTemplates]);

  // Build sequence menu items
  useEffect(() => {
    if (!activeContactModel || !activeContactModel.id || !userSequenceTemplates.length) {
      setSequenceMenuItems([]);
      return;
    }

    // Group sequences by category (mirrors the message-template grouping above)
    const groupedSequences = _.groupBy(userSequenceTemplates, (seq: any) => seq.category || 'Uncategorized');
    const sortedCategories = _.orderBy(Object.keys(groupedSequences), [category => category.toLowerCase()], ['asc']);

    const items = _.map(sortedCategories, (category) => ({
      key: `seq-cat-${category}`,
      label: category,
      children: _.map(_.orderBy(groupedSequences[category], [(seq: any) => (seq.name || '').toLowerCase()], ['asc']), (seq: any) => ({
        key: `seq-${seq.id}`,
        label: (
          <Tooltip
            title={`${seq.name} — ${parseInt(seq.modules_count) || 0} steps. Click to load the first message.`}
            placement="right"
            color="#722ed1"
            styles={{ body: { color: 'white' } }}
          >
            <div className="message-template-menu" style={{ maxWidth: "220px" }}>
              <Text ellipsis>
                {seq.name}
              </Text>
            </div>
          </Tooltip>
        ),
        onClick: async () => {
          try {
            const res = await getSequencePreview(seq.id);
            const preview = res.data || res;
            if (preview.message) {
              const previewMessage = replaceMergeFields(preview.message);
              setMessage(previewMessage);
              setPendingSequence({
                modulegroup_id: preview.modulegroup_id,
                name: preview.name,
              });
              showSuccess('sequenceLoaded');
            }
          } catch (err) {
            console.error('Failed to load sequence preview:', err);
            showError('sequencePreview');
          }
        },
      })),
    }));

    setSequenceMenuItems(items);
  }, [activeContactModel, userSequenceTemplates]);

  useEffect(() => {
    if (onSchedulingChange) {
      onSchedulingChange(messageHasScheduling);
    }
  }, [messageHasScheduling, onSchedulingChange]);

  useEffect(() => {
    // Turn off interview scheduling if message is empty — EXCEPT while a
    // scheduling manager with no calendar of their own is mid-flow. There,
    // scheduling is legitimately on with an empty composer until they pick a
    // teammate (whose invite template then fills the message); without this
    // guard the effect fired instantly and made the switch flicker off.
    const managerPickingTeammate = hasSchedulingManager && !hasCalendarConnected;
    if (messageHasScheduling && message.trim() === "" && !managerPickingTeammate) {
      setMessageHasScheduling(false);
    }
  }, [message, messageHasScheduling, hasSchedulingManager, hasCalendarConnected]);

  // Availability guard: fetch the booking calendar's available-slot count (next 15
  // days) so we can block sending an invite that can't be booked. Booking owner =
  // the chosen teammate, else the sender's own calendar. null = still fetching.
  useEffect(() => {
    if (!messageHasScheduling) { setBookingSlotCount(null); return undefined; }
    const currentUserId = String(session.get("userData")?.id || "");
    const bookingOwnerId = schedulingUserId || currentUserId;
    if (!bookingOwnerId) { setBookingSlotCount(null); return undefined; }
    let cancelled = false;
    setBookingSlotCount(null);
    getCalendarPreview(bookingOwnerId, new Date().toISOString())
      .then((res: any) => {
        if (cancelled) return;
        const body = res?.data?.data ?? res?.data ?? [];
        const slots = Array.isArray(body) ? body : (body.schedules || []);
        const count = body && body.error ? 0 : slots.filter((s: any) => s.ghslot && s.available).length;
        setBookingSlotCount(count);
      })
      .catch(() => { if (!cancelled) setBookingSlotCount(0); });
    return () => { cancelled = true; };
  }, [messageHasScheduling, schedulingUserId]);

  // Concrete 0 (not null/loading) means the chosen calendar has no bookable times.
  const bookingHasNoSlots = messageHasScheduling && bookingSlotCount === 0;

  const isOptedOut = activeContactModel?.blacklist;

  // messaging.send gate — swap the whole composer for a locked banner. Safe as
  // an early return: every hook in this component runs above this line.
  if (!canSend) {
    return (
      <Row justify="space-between" align="top" gutter={3}>
        <Col span={24}>
          <FeatureLockBanner featureKey="messaging.send" />
        </Col>
      </Row>
    );
  }

  return (
    <Row justify="space-between" align="top" gutter={3}>
      <Col span={24}>
        <Spin spinning={isSending}>
          {/* <Row>
            <Col></Col>
          </Row> */}

          {isOptedOut && (
            <Alert
              message="This contact has opted out of messaging"
              type="info"
              showIcon
              icon={<StopOutlined style={{ color: '#ff4d4f', fontSize: 12 }} />}
              style={{ marginBottom: 8 }}
            />
          )}

          {/* ADR-025: channel picker — only when the contact can be reached on more than one */}
          {showChannelPicker && (
            <div style={{ marginBottom: 6, display: 'flex', alignItems: 'center', gap: 8 }} data-testid="composer-channel-picker">
              <Segmented
                size="small"
                value={selectedChannel}
                disabled={isSending || !!preview}
                onChange={(value) => setComposerChannel(value as Channel)}
                options={[
                  {
                    value: 'sms',
                    label: (
                      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
                        <ChannelIcon channel="sms" size={12} /> SMS
                      </span>
                    ),
                    disabled: !smsChannel,
                  },
                  {
                    value: 'whatsapp',
                    label: (
                      <Tooltip title={!waChannel ? 'No WhatsApp conversation yet' : (messageHasScheduling ? 'Interview invites are sent over SMS' : undefined)}>
                        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
                          <ChannelIcon channel="whatsapp" size={12} /> WhatsApp
                        </span>
                      </Tooltip>
                    ),
                    disabled: !waChannel || messageHasScheduling,
                  },
                ]}
              />
            </div>
          )}

          {/* ADR-025: WhatsApp 24h window — free-form while open, otherwise choose a fallback */}
          {isWhatsApp && !needsFallback && (
            <div
              data-testid="whatsapp-window-line"
              style={{ marginBottom: 6, display: 'flex', alignItems: 'center', gap: 8, fontSize: 12, color: '#8c8c8c' }}
            >
              <WhatsAppWindowChip state={windowState} hasConversation={!!waChannel?.conversationId} />
              <span>
                Free-form until {windowState.expiresAt ? formatExpiry(windowState.expiresAt) : '—'} · {formatRemaining(windowState.remainingMs)}
              </span>
            </div>
          )}
          {isWhatsApp && needsFallback && (
            <Alert
              type="warning"
              showIcon
              data-testid="whatsapp-window-closed"
              style={{ marginBottom: 8 }}
              message="WhatsApp window closed"
              description={(
                <div>
                  <div style={{ marginBottom: 6 }}>
                    {contactFirstName} hasn’t replied in 24 hours, so this can’t go as a free-form WhatsApp message. Choose how to send:
                  </div>
                  <Radio.Group
                    value={fallbackChoice}
                    onChange={(e) => setFallbackChoice(e.target.value)}
                    disabled={isSending}
                    style={{ display: 'flex', flexDirection: 'column', gap: 6 }}
                  >
                    <Radio value="sms" disabled={!availability.sms} data-testid="fallback-sms">
                      <span>Send as SMS{activeContactModel?.mobile ? ` to ${activeContactModel.mobile}` : ''}</span>
                      <div style={{ fontSize: 11, color: '#8c8c8c' }}>Uses your texting number. Lands in this same timeline.</div>
                    </Radio>
                    <Radio value="template" disabled={!availability.template} data-testid="fallback-template">
                      <span>Send WhatsApp template “Continue conversation”</span>
                      <div style={{ fontSize: 11, color: '#8c8c8c' }} data-testid="template-hint">
                        {templateFallbackHint(waTemplate?.hasTextParam, contactFirstName)}
                      </div>
                      {fallbackChoice === 'template' && (
                        <div
                          data-testid="template-preview"
                          style={{ marginTop: 6, padding: '6px 8px', background: '#fff', border: '1px solid #d9d9d9', borderRadius: 6, fontSize: 12, color: '#262626', whiteSpace: 'pre-wrap' }}
                        >
                          {waTemplate?.preview
                            ? renderWindowTemplatePreview(waTemplate.preview, message)
                            : `Hi ${contactFirstName}, a message from ${session.get("userData")?.companyName || 'us'}: “${message.trim() || '…'}” Reply to continue the conversation.`}
                        </div>
                      )}
                    </Radio>
                    <Radio value="hold" data-testid="fallback-hold">
                      <span>Hold until {contactFirstName} replies</span>
                      <div style={{ fontSize: 11, color: '#8c8c8c' }}>Sent automatically on WhatsApp the moment a reply opens the window. Shows as a pending bubble you can cancel.</div>
                    </Radio>
                  </Radio.Group>
                </div>
              )}
            />
          )}

          <Flex align="start" gap="small" style={{ marginTop: "0px" }}>
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
              <div
                style={{
                  flex: 1,
                  border: "1px solid #d9d9d9",
                  borderRadius: 6,
                  padding: 6,
                  display: 'flex',
                  flexDirection: 'column',
                  opacity: !activeContact || isOptedOut ? 0.5 : 1,
                  backgroundColor: !activeContact || isOptedOut ? '#f5f5f5' : 'transparent',
                  pointerEvents: isOptedOut ? 'none' : 'auto',
                }}
              >
                {/* Anchor span + Popover for link clicks */}
                <MessageRichEditor
                  message={message}
                  setMessage={setMessage}
                  activeContact={activeContact}
                  activeContactModel={activeContactModel}
                  isSending={isSending || !!preview}
                  onProcessingChange={setIsProcessingLinks}
                  excludedClearTrigger={excludedClearTrigger}
                />

                {/* ADR-035: translation preview — review / edit before it goes out */}
                {preview && (
                  <div
                    className="gh-translation-preview"
                    style={{ margin: '4px 0 6px', padding: 8, background: '#f0f5ff', border: '1px solid #adc6ff', borderRadius: 6 }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, color: '#1d39c4', marginBottom: 6, flexWrap: 'wrap' }}>
                      <TranslationOutlined />
                      <strong>Translation · {langName(preview.targetLang)}</strong>
                      <span style={{ color: '#8c8c8c' }}>— review or edit before sending</span>
                      <span style={{ marginLeft: 'auto', color: preview.text.length > maxLen ? 'red' : '#8c8c8c' }}>
                        {preview.text.length}/{maxLen}
                      </span>
                    </div>
                    <Input.TextArea
                      autoSize={{ minRows: 2, maxRows: 8 }}
                      value={preview.text}
                      onChange={(e) => setPreview({ ...preview, text: e.target.value })}
                      disabled={isSending}
                      lang={preview.targetLang}
                    />
                    <div style={{ display: 'flex', gap: 8, marginTop: 8, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
                      <Button size="small" onClick={() => setPreview(null)} disabled={isSending}>Back to edit</Button>
                      <Button size="small" onClick={onSendOriginal} disabled={isSending}>Send original instead</Button>
                      <Button
                        size="small"
                        type="primary"
                        icon={<SendOutlined />}
                        loading={isSending}
                        disabled={!preview.text.trim() || preview.text.length > maxLen}
                        onClick={onSendTranslated}
                        style={{ backgroundColor: '#4cb04f', borderColor: '#4cb04f' }}
                      >
                        Send in {langName(preview.targetLang)}
                      </Button>
                    </div>
                  </div>
                )}
                {previewError && (
                  <Alert
                    type="error"
                    showIcon
                    closable
                    onClose={() => setPreviewError(null)}
                    style={{ margin: '4px 0 6px' }}
                    message={previewError.message}
                    action={(
                      <Space size={4}>
                        {previewError.code !== 'TRANSLATION_DISABLED' && (
                          <Button size="small" onClick={onPressTranslatePreview} loading={isTranslating}>Retry</Button>
                        )}
                        <Button size="small" onClick={onSendOriginal}>Send original</Button>
                      </Space>
                    )}
                  />
                )}


                {pendingSequence && (
                  <div style={{ padding: '4px 8px', color: '#722ed1', display: 'flex', alignItems: 'center', gap: '6px', fontSize: 12, marginBottom: '4px', background: '#f9f0ff', borderRadius: 4 }}>
                    <RobotOutlined style={{ fontSize: 14 }} />
                    <span>Sending will start sequence: <strong>{pendingSequence.name}</strong></span>
                    <Button type="link" size="small" style={{ padding: 0, fontSize: 12, color: '#9254de' }} onClick={() => { setPendingSequence(null); setMessage(""); }}>Cancel</Button>
                  </div>
                )}

                {messageHasScheduling && (
                  <div style={{ padding: '0px 5px', color: '#374151', display: 'flex', alignItems: 'center', gap: '6px', fontWeight: 600, marginBottom: '4px' }}>
                    <Tooltip title={"Appended to your message when scheduling is enabled."} placement="top">
                      <LockOutlined style={{ color: 'red', fontSize: 16 }} />
                    </Tooltip>
                    <span style={{ fontWeight: 600, color: '#374151' }}>{constants.interviewInviteAppend}</span>
                  </div>
                )}

                {messageHasScheduling && hasSchedulingManager && (
                  <div style={{ padding: '2px 5px 4px' }}>
                    <CalendarOwnerPicker
                      compact
                      value={schedulingUserId}
                      onChange={onSchedulingUserChange}
                      size="small"
                    />
                  </div>
                )}

                {bookingHasNoSlots && (
                  <div style={{ padding: '0px 5px 4px', color: '#ff4d4f', fontSize: 12, display: 'flex', alignItems: 'center', gap: 6 }}>
                    <ExclamationCircleOutlined /> No available interview times on the selected calendar (next 15 days).
                  </div>
                )}

                <div style={{  display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 'auto' }}>
                  <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                    <Dropdown
                      disabled={!activeContact || isSending || isOptedOut}
                      menu={{ items: messageMenuItems, mode: 'inline' }}
                      placement="topRight"
                      overlayClassName="inboxV2-templates-menu"
                    >
                      <Button size="middle" shape="circle" icon={<MoreOutlined />} disabled={isOptedOut} />
                    </Dropdown>

                    {!canSchedule ? (
                      // Shown-but-locked: antd swallows clicks on a disabled
                      // Switch, so LockedControl catches them on a wrapper.
                      <LockedControl featureKey="interview-scheduling">
                        <Switch
                          checked={false}
                          disabled
                          checkedChildren={<><CalendarFilled /> On</>}
                          unCheckedChildren={<><LockOutlined /> Off</>}
                        />
                      </LockedControl>
                    ) : (hasCalendarConnected || hasSchedulingManager) ? (
                      <Popconfirm
                        title={isInterviewInviteConfirmOpen ? "Replace existing message with interview invite?" : "Clear the message?"}
                        description={isInterviewInviteConfirmOpen ? "The current message will be replaced with the interview invite message." : "Turning off interview scheduling will clear the current message."}
                        open={isInterviewInviteConfirmOpen || isTurnOffConfirmOpen}
                        onConfirm={isInterviewInviteConfirmOpen ? onInterviewInviteConfirm : onTurnOffConfirm}
                        onCancel={isInterviewInviteConfirmOpen ? onInterviewInviteCancel : onTurnOffCancel}
                        okText={isInterviewInviteConfirmOpen ? "Replace" : "Clear"}
                        cancelText="Retain"
                      >
                        <Tooltip title={isWhatsApp ? "Interview invites are sent over SMS" : "Interview Scheduling"} placement="topLeft">
                          <Switch
                            checked={messageHasScheduling}
                            loading={isSwitchLoading || isProcessingLinks}
                            disabled={!activeContact || isProcessingLinks || isOptedOut || isWhatsApp}
                            onChange={async (checked) => {
                              if (checked) {
                                setIsSwitchLoading(true);
                                await onClickInterviewScheduling();
                                setIsSwitchLoading(false);
                              } else {
                                if (messageHasScheduling && message.trim() !== "") {
                                  setIsTurnOffConfirmOpen(true);
                                } else {
                                  setMessageHasScheduling(false);
                                }
                              }
                            }}
                            checkedChildren={<><CalendarFilled /> On</>}
                            unCheckedChildren={<><CalendarFilled /> Off</>}
                            style={messageHasScheduling ? { background: '#4cb04f', borderColor: '#4cb04f' } : {}}
                          />
                        </Tooltip>
                      </Popconfirm>
                    ) : (
                      <Popconfirm
                        title="You need to connect your calendar to use interview scheduling."
                        open={isCalendarSetupConfirmOpen}
                        onConfirm={() => {
                          setIsCalendarSetupConfirmOpen(false);
                          goToCalendarIntegration();
                        }}
                        onCancel={() => setIsCalendarSetupConfirmOpen(false)}
                        okText="Connect"
                        cancelText="Cancel"
                      >
                        <Tooltip title={isWhatsApp ? "Interview invites are sent over SMS" : "Interview Scheduling"} placement="topLeft">
                          <Switch
                            checked={false}
                            disabled={!activeContact || isProcessingLinks || isOptedOut || isWhatsApp}
                            onClick={() => setIsCalendarSetupConfirmOpen(true)}
                            checkedChildren={<><CalendarFilled /> On</>}
                            unCheckedChildren={<><CalendarFilled /> Off</>}
                          />
                        </Tooltip>
                      </Popconfirm>
                    )}

                    {/* ADR-035: translate-before-send. Same shown-but-locked treatment as scheduling. */}
                    {translationAvailable ? (
                      <Tooltip
                        title={translateOn
                          ? `Send translates your message${messageHasScheduling ? ' (booking sentence included)' : ''} into ${langName(contactLang)} and shows a preview first`
                          : `Off — sends exactly what you type (contact writes in ${langName(contactLang)})`}
                        placement="topLeft"
                      >
                        <Switch
                          checked={translateOn}
                          disabled={!activeContact || isOptedOut || !!preview || isTranslating}
                          onChange={(checked) => persistTranslateOn(checked)}
                          checkedChildren={<><TranslationOutlined /> {langName(contactLang)}</>}
                          unCheckedChildren={<><TranslationOutlined /> Off</>}
                          style={translateOn ? { background: '#1d39c4', borderColor: '#1d39c4' } : {}}
                        />
                      </Tooltip>
                    ) : (!canTranslate && languageDiffers && !!activeContact) ? (
                      <LockedControl featureKey="ai-translation">
                        <Switch
                          checked={false}
                          disabled
                          checkedChildren={<><TranslationOutlined /> On</>}
                          unCheckedChildren={<><LockOutlined /> Off</>}
                        />
                      </LockedControl>
                    ) : null}

                  </div>

                  <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>

                    {message.length > 0 && (() => {
                      const totalLength = message.length + (messageHasScheduling ? constants.interviewInviteAppend.length : 0);
                      return (
                        <span style={{ color: totalLength > maxLen ? 'red' : '#999', fontSize: '12px' }} data-testid="composer-char-counter">
                          {totalLength > maxLen && <ExclamationCircleOutlined />} {totalLength}/{maxLen} characters
                        </span>
                      );
                    })()}

                    {(() => {
                      const sendDisabled = !activeContact || isSending || isTranslating || !!preview || isProcessingLinks || message.length === 0 || (message.length + (messageHasScheduling ? constants.interviewInviteAppend.length : 0)) > maxLen || isOptedOut || bookingHasNoSlots;
                      const sendLabel = needsFallback ? FALLBACK_SEND_LABEL[fallbackChoice] : 'Send';
                      const sendTitle = isOptedOut
                        ? "Contact has opted out"
                        : (bookingHasNoSlots
                          ? "No available interview times on the selected calendar (next 15 days)"
                          : (willTranslate
                            ? `Translate to ${langName(contactLang)} & preview`
                            : (isWhatsApp ? (needsFallback ? sendLabel : 'Send on WhatsApp') : "Send Message")));
                      const sendIcon = isTranslating ? <LoadingOutlined /> : (willTranslate ? <TranslationOutlined /> : <SendOutlined />);
                      const onSend = willTranslate ? onPressTranslatePreview : (messageHasScheduling ? onPressSendCalendarInvite : onPressSendMessage);
                      const activeStyle = { backgroundColor: willTranslate ? '#1d39c4' : '#4cb04f', borderColor: willTranslate ? '#1d39c4' : '#4cb04f', color: 'white' };
                      return (
                        <Tooltip title={sendTitle} placement="top">
                          {needsFallback ? (
                            <Button
                              size="middle"
                              type="primary"
                              data-testid="composer-send-fallback"
                              disabled={sendDisabled}
                              icon={sendIcon}
                              onClick={onSend}
                              style={!sendDisabled ? activeStyle : {}}
                            >
                              {sendLabel}
                            </Button>
                          ) : (
                            <Button
                              size="large"
                              shape="circle"
                              data-testid="composer-send"
                              disabled={sendDisabled}
                              icon={sendIcon}
                              onClick={onSend}
                              style={!sendDisabled ? activeStyle : {}}
                            />
                          )}
                        </Tooltip>
                      );
                    })()}
                  </div>
                </div>
              </div>
            </div>
          </Flex>
        </Spin>
      </Col>
    </Row>
  );
};

const mapDispatchToProps = (dispatch) => ({
  goToCalendarIntegration: () => {
    dispatch(push(`/interview-invites?tab=integrations`));
  },
});

export default connect(null, mapDispatchToProps)(MessageInputField);
